export default __webpack_public_path__ + "static/nick-85bcecc225b2b1489f1415d0a29a02b6.png";